import React, { useMemo } from 'react';
import CommonRequestPage from '../CommonRequestPage';
import apiSpec from '../../benepay-b2b-api.json';

export default function RefundRequest() {
    // Locate the refund endpoint in the spec
    const pageData = useMemo(() => {
        const path = '/v1/requestRefund';
        const method = 'post';
        const methodDetails = apiSpec.paths?.[path]?.[method] || {};

        // request schema
        const requestSchemaRef = methodDetails.requestBody?.content?.['application/json']?.schema?.$ref;
        const requestSchemaName = requestSchemaRef ? requestSchemaRef.split('/').pop() : null;
        let requestSchema = requestSchemaName ? apiSpec.components?.schemas?.[requestSchemaName] : null;

        // Special case: Refund is encrypted wrapper -> show inner RefundRequestV1 for parameters
        if (requestSchemaName === 'RefundEncryptedRequest') {
            const innerSchema = apiSpec.components?.schemas?.['RefundRequestV1'];
            if (innerSchema) {
                requestSchema = innerSchema;
            }
        }

        const requiredFields = requestSchema?.required || [];
        const parameters = methodDetails.parameters || [];

        return {
            title: methodDetails.summary || 'Refund Initiation',
            description: methodDetails.description || '',
            path,
            method: method.toLowerCase(),
            requestSchema,
            requiredFields,
            parameters,
            payloadEncryption: !!methodDetails.payloadEncryption,
            responseDecryption: !!methodDetails.responseDecryption,
            requestExample: methodDetails.sampleRequest || {},
            responseExample: methodDetails.sampleResponse || {},
            paymentMethods: [],
            showRedirectStatus: false,
        };
    }, []);

    return <CommonRequestPage {...pageData} />;
}
